const validateEmail = (email: string): boolean => /^[^@]+@[\w\W]+(\.\w+)+\w$/.test(email);

export default validateEmail;